<template>
  <div class="external-list">
    <div class="is-variable external-list-section">
      <div class="external-cards-section">
        <FormGiftExternalList
          v-for="(list, index) in externalList"
          :key="Math.random() + index"
          :index="index"
          :externalList="externalList"
          :errors="errors"
          ref="forms"
          @remove="removeItem"
          @save="saveItem"
        />

        <div class="add-section" v-if="externalList.length < 10">
          <button
            class="button is-outlined"
            @click="addExternalList()"
            style="width: auto"
          >
            <i
              class="fa fa-plus-circle"
              aria-hidden="true"
              style="color: #5d758d; margin-right: 8px"
            ></i
            >Adicionar outra lista
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import GiftsApi from '@/lib/api/Gifts'
import FormGiftExternalList from './FormGiftExternalList.vue'

import bannerImage from '@/assets/img/banners-external-list.png'

const EMPTY_ITEM = {
  sys: '',
  name: '',
  url: '',
  address: '',
}

const MAX_GIFT_LIST_EXTERNAL = 10

export default {
  data() {
    return {
      externalListSaved: [],
      externalList: [],
      errors: undefined,
      url: '',
      bannerImage,
    }
  },

  components: {
    FormGiftExternalList,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
    wedId() {
      return this.logonToken.token_payload.wed_id
    },
    storesExternal: {
      get() {
        return this.$store.state.gifts.storesExternal
      },
      set(payload) {
        this.$store.dispatch('gifts/setStoresExternal', payload)
      },
    },
    notificationAlert: {
      get() {
        return this.$store.state.app.notification
      },
      set(payload) {
        this.$store.dispatch('app/setNotification', payload)
      },
    },
  },

  async mounted() {
    await this.getGiftListsExternal()
    this.setGiftListInitialData()
    this.getStoresExternal()
  },

  methods: {
    ...mapActions({
      setSaving: 'gifts/setSaving',
    }),

    addExternalList() {
      this.externalList.push({ ...EMPTY_ITEM })
      setTimeout(() => {
        this.$refs.forms[this.externalList.length - 1]?.fadeComponent()
      }, 200)
    },

    removeItem(indexToRemove) {
      this.externalList = this.externalList.filter(
        (item, index) => index != indexToRemove
      )
      this.saveGiftListsExternal()

      if (!this.externalList.length) this.externalList.push({ ...EMPTY_ITEM })
    },

    saveItem(index, item) {
      this.externalList[index] = item
      this.saveGiftListsExternal()
    },

    _transformLegacyDataToArray() {
      for (let i = 1; i <= MAX_GIFT_LIST_EXTERNAL; i++) {
        const key = 'externa' + i
        if (this.externalListSaved[key + '_loja']) {
          this.externalList.push({
            sys: this.externalListSaved[key + '_sys'] ?? '',
            name: this.externalListSaved[key + '_loja'] ?? '',
            url: this.externalListSaved[key + '_url'] ?? '',
            address: this.externalListSaved[key + '_endereco'] ?? '',
          })
        }
      }
    },

    _transformInEmptyListWithTwoItemsIfNecessary() {
      if (!this.externalList.length) {
        this.externalList = [{ ...EMPTY_ITEM }, { ...EMPTY_ITEM }]
      }
    },

    _addEmptyItemIfExistsOnlyOneStoreSaved() {
      if (this.externalList.length === 1) {
        this.externalList.push({ ...EMPTY_ITEM })
      }
    },

    setGiftListInitialData() {
      this.externalList = []
      this._transformLegacyDataToArray()
      this._transformInEmptyListWithTwoItemsIfNecessary()
      this._addEmptyItemIfExistsOnlyOneStoreSaved()
    },

    getStoresExternal() {
      if (!this.storesExternal.length) {
        const giftsApi = new GiftsApi(this.logonToken)

        giftsApi
          .getGiftsExternalListStores()
          .then((response) => {
            this.storesExternal = response.data
          })
          .catch((error) => {
            console.error('Error to get stores external ', error)
          })
      }
    },

    async getGiftListsExternal() {
      const giftsApi = new GiftsApi(this.logonToken)

      await giftsApi
        .getGiftsExternalList()
        .then((response) => {
          this.externalListSaved = response.data
        })
        .catch((error) => {
          console.error('Error to get gift lists external ', error)
        })
    },

    saveGiftListsExternal() {
      const list = {}
      for (let i = 0; i < MAX_GIFT_LIST_EXTERNAL; i++) {
        list[`externa${i + 1}_sys`] = this.externalList[i]?.sys || null
        list[`externa${i + 1}_loja`] = this.externalList[i]?.name || null
        list[`externa${i + 1}_url`] = this.externalList[i]?.url || null
        list[`externa${i + 1}_endereco`] = this.externalList[i]?.address || null
      }

      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi
        .editGiftsExternalList(list)
        .then((response) => {
          if (response.errors) {
            this.errors = response.errors
            throw 'validation errors'
          } else {
            this.errors = undefined
          }
          this.externalListSaved = response.data
          this.setSaving(true)
          this.notificationAlert = {
            message: 'As alterações foram salvas com sucesso.',
            show: true,
          }
        })
        .catch(() => {
          console.error('Error to save gift lists external')
          this.notificationAlert = {
            message: 'As alterações não foram salvas.',
            class: 'is-error',
            show: true,
          }
        })
    },
  },
}
</script>
<style lang="scss">
.layout-dashboard {
  overflow: visible;
}

.external-list-section {
  display: flex;
  text-align: center;
  flex-direction: column;
  @media screen and (min-width: 1920px) {
    flex-direction: row-reverse;
    gap: 16px;
  }
}

.external-cards-section {
  width: 100%;
}
.external-list {
  margin-top: 48px;
}

.is-outlined:hover {
  color: $neutraldarkest;
  border: none !important;
}

.is-outlined:focus {
  color: $neutraldarkest;
  border: none !important;
  box-shadow: none !important;
}
.is-outlined {
  border: none !important;
  background: none;
}

.add-section {
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 800px) {
    display: inline-block;
    margin-top: -10px;

    button {
      margin-bottom: 20px;
    }
  }
}

.external-list-section {
  @media (min-width: 800px) and (max-width: 1400px) {
    .external-cards-section {
      .external-list-card {
        margin-right: 0px;
        width: inherit;
      }
    }
  }
}

</style>
